import { CouponValidateResponse, ServicePaymentMethod } from "@/apis/clients";
import {
  buildPaidPaymentResetPatch,
  shouldResetPaymentSelection,
} from "@/states/service-form/paymentGuard";
import {
  buildCouponContextKey,
  getCreditSettlementAmount,
} from "@/states/service-form/pricing";
import {
  FormPayment,
  ServiceFormServiceInputs,
  ServiceInfo,
} from "@/states/service-form/types";

export const COUPON_AUTO_REMOVED_MESSAGE =
  "選択内容が変更されたため、適用中のクーポンを解除しました。";

export const isCouponSupportedService = (service: ServiceInfo): boolean =>
  service.type === "event-seminar" ||
  service.type === "form" ||
  service.type === "calendar";

export const buildCouponAppliedPayment = (
  result: CouponValidateResponse,
  service: ServiceInfo,
  serviceInputs: ServiceFormServiceInputs,
  settlementMethod: number | undefined,
): FormPayment => {
  const freePaymentResetPatch =
    result.final_amount <= 0 ? buildPaidPaymentResetPatch(result.final_amount) : {};

  return {
    billingAmount: result.final_amount,
    settlementAmount:
      settlementMethod === ServicePaymentMethod.CREDIT
        ? result.credit_settlement_amount ??
          getCreditSettlementAmount(result.final_amount)
        : result.final_amount,
    couponId: result.coupon_id,
    couponCode: result.code,
    couponDiscountAmount: result.discount_amount,
    couponEligibleSubtotal: result.eligible_subtotal,
    couponLabel: result.label,
    couponContextKey: buildCouponContextKey(service, serviceInputs),
    ...freePaymentResetPatch,
  };
};

export const buildCouponClearedPayment = (
  baseAmount: number,
  settlementMethod: number | undefined,
): FormPayment => {
  const paymentResetPatch = buildPaidPaymentResetPatch(baseAmount);
  const effectiveSettlementMethod = shouldResetPaymentSelection(baseAmount)
    ? undefined
    : settlementMethod;

  return {
    billingAmount: baseAmount,
    settlementAmount:
      effectiveSettlementMethod === ServicePaymentMethod.CREDIT
        ? getCreditSettlementAmount(baseAmount)
        : baseAmount,
    couponId: undefined,
    couponCode: undefined,
    couponDiscountAmount: undefined,
    couponEligibleSubtotal: undefined,
    couponLabel: undefined,
    couponContextKey: undefined,
    ...paymentResetPatch,
  };
};
